import { takeEvery, select, put } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import { get } from 'lodash';
import * as blacklistActions from 'actions/Blacklist';
import * as powerboxActions from 'actions/Powerbox';
import * as licenseActions from 'actions/License';
import * as userActions from 'actions/User';

import history from 'utils/history';
import { Slide, toast } from 'react-toastify';
import { GET_CHILD_ORGANIZATION } from 'actions/Organizations';
import { t } from 'i18n';

const getBlacklistEntries = apiRequest.bind(null, blacklistActions.getBlacklistEntries, api.getBlacklistEntries);
const getBlacklistPowerbox = apiRequest.bind(null, blacklistActions.getBlacklistPowerbox, api.getBlacklistEntries);
const getBlacklistLicense = apiRequest.bind(null, blacklistActions.getBlacklistLicense, api.getBlacklistEntries);
const getBlacklistEntry = apiRequest.bind(null, blacklistActions.getBlacklistEntry, api.getBlacklistEntry);
const moveToBlacklist = apiRequest.bind(null, blacklistActions.moveToBlacklist, api.moveToBlacklist);

const deleteFromBlacklist = apiRequest.bind(null, blacklistActions.deleteFromBlacklist, api.deleteFromBlacklist);

function* refreshList() {
  const state = yield select();

  yield put({
    type: blacklistActions.GET_BLACKLIST_POWERBOX.REQUEST,
    payload: {
      data: {
        powerboxContains: get(state, 'Blacklist.powerboxTableFilter.search'),
      },
    },
  });

  const licenseArg = {
    data: {
      licenseContains: get(state, 'Blacklist.licenseTableFilter.search'),
    },
  };
  yield apiRequest.apply(null, [blacklistActions.getBlacklistLicense, api.getBlacklistEntries, licenseArg]);
  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.saved'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });
}

function* handleMoveToBlacklist(action) {
  const state = yield select();

  if (history.location.pathname.includes('/update-organization')) {
    yield put({
      type: GET_CHILD_ORGANIZATION.REQUEST,
      id: get(action.payload, 'organizationId'),
    });

    return null;
  }

  if (history.location.pathname.includes('/update-user') || history.location.pathname.includes('/view-user')) {
    yield put({
      type: userActions.GET_USER.REQUEST,
      id: get(action.payload, 'userId'),
    });

    return null;
  }

  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.saved'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });

  if (window.location.pathname.includes('powerbox')) {
    const arg = {
      data: {
        powerboxContains: get(state, 'Powerbox.tableFilter.search'),
        powerboxDisplayScope: get(state, 'Powerbox.tableFilter.powerboxDisplayScope'),
        sortBy: get(state, 'Powerbox.tableSorting.sortBy'),
        sortDirection: get(state, 'Powerbox.tableSorting.sortDirection') || 'ASC',
      },
    };

    yield apiRequest.apply(null, [powerboxActions.getPowerboxList, api.getPowerboxList, arg]);

    return;
  }

  if (window.location.pathname.includes('license')) {
    yield put({
      type: licenseActions.GET_LICENSES.REQUEST,
      payload: {
        data: {
          licenseContains: get(state, 'License.tableFilter.search'),
        },
      },
    });
    return;
  }

  const licenseArg = {
    data: {
      licenseContains: get(state, 'Blacklist.licenseTableFilter.search'),
      entityType: 'license',
    },
  };

  const powerboxArg = {
    data: {
      powerboxContains: get(state, 'Blacklist.powerboxTableFilter.search'),
      entityType: 'powerbox',
    },
  };

  yield apiRequest.apply(null, [blacklistActions.getBlacklistPowerbox, api.getBlacklistEntries, powerboxArg]);
  yield apiRequest.apply(null, [blacklistActions.getBlacklistLicense, api.getBlacklistEntries, licenseArg]);
}
// function* handleUserOrganizationsRefresh() {
//   const getUserUuid = (state) => state.User.user.userUuid;
//   const userUuid = yield select(getUserUuid);

//   const arg = { id: userUuid }

//   yield apiRequest.apply(null, [ blacklistActions.getUserOrganizations, api.getUserOrganizations, arg ])
// }

/******************************************************************************/
/******************************* WATCHERS *************************************/

/******************************************************************************/

export function* wathcGetBlacklistEntriesRequest() {
  yield takeEvery(blacklistActions.GET_BLACKLIST_ENTRIES.REQUEST, getBlacklistEntries);
}

export function* wathcGetBlacklistPowerboxRequest() {
  yield takeEvery(blacklistActions.GET_BLACKLIST_POWERBOX.REQUEST, getBlacklistPowerbox);
}

export function* wathcGetBlacklistLicenseRequest() {
  yield takeEvery(blacklistActions.GET_BLACKLIST_LICENSE.REQUEST, getBlacklistLicense);
}

export function* wathcGetBlacklistEntryRequest() {
  yield takeEvery(blacklistActions.GET_BLACKLIST_ENTRY.REQUEST, getBlacklistEntry);
}

export function* watchMoveToBlacklistRequest() {
  yield takeEvery(blacklistActions.MOVE_TO_BLACKLIST.REQUEST, moveToBlacklist);
}

export function* watchMoveToBlacklistSuccess() {
  yield takeEvery(blacklistActions.MOVE_TO_BLACKLIST.SUCCESS, handleMoveToBlacklist);
}

export function* watchDeleteFromBlacklistRequest() {
  yield takeEvery(blacklistActions.DELETE_FROM_BLACKLIST.REQUEST, deleteFromBlacklist);
}

export function* watchDeleteFromBlacklistSuccess() {
  yield takeEvery(blacklistActions.DELETE_FROM_BLACKLIST.SUCCESS, refreshList);
}
